import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function source() {
  try {
    const ref = document.referrer;
    if (!ref) return "direct";
    if (ref.includes("instagram")) return "instagram";
    if (ref.includes("google") || ref.includes("bing")) return "search";
    return "referral";
  } catch { return "direct"; }
}

export function trackPage(page) {
  api.post("/analytics/pageview", { page, source: source() }).catch(() => {});
}

export function trackEvent(event, meta) {
  api.post("/analytics/event", { event, meta }).catch(() => {});
}
